import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import DataTables from "views/admin/tables";
import Uploads from "views/admin/uploads";

// Auth Imports

// Icon Imports
import {
  MdHome,
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
} from "react-icons/md";
import { layout } from "@chakra-ui/system";
import { UploadsXmlZipFile } from "views/admin/uploadXmlZipFile";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Input Files",
    layout: "/admin",
    path: "files-data",
    icon: <MdOutlineShoppingCart className="h-6 w-6" />,
    component: <DataTables />,
    secondary: true,
  },
  // {
  //   name: "BOU Switch Data",
  //   layout: "/admin",
  //   icon: <MdBarChart className="h-6 w-6" />,
  //   path: "data-tables",
  //   component: <DataTables />,
  // },
  {
    name: "Upload Files",
    layout: "/admin",
    path: "upload-data",
    icon: <MdPerson className="h-6 w-6" />,
    component: <Uploads />,
  },
  {
    name: "Upload Xml Zip File",
    layout: "/admin",
    path: "upload-xml-zip-file",
    icon: <MdPerson className="h-6 w-6" />,
    component: <UploadsXmlZipFile />,
  },
  {
    name: "Available Files",
    layout: "/admin",
    path: "available-data",
    icon: <MdPerson className="h-6 w-6" />,
    component: <DataTables />,
  },
];
export default routes;
